import { Checkbox } from '@components/checkbox';
import { formatCurrency } from '@utils/number';
import { Typography } from '@mui/material';
import { TableGridBaseColDef, TableGridRenderCellParams } from '@components/table/types/TableColumnDef.type';

export const getGLOptionalCoveragesColumns = ({
  acceptedByCodeName,
  updateAccepted,
}: {
  acceptedByCodeName: Record<string, boolean>;
  updateAccepted: (indicatorCodeName: string, accepted: boolean) => void;
}): TableGridBaseColDef<any>[] => [
  {
    renderHeader: () => '',
    headerName: undefined,
    field: 'updateAccepted',
    flex: 0.5,
    sortable: false,
    renderCell: (params: TableGridRenderCellParams) => (
      <Checkbox
        checked={!!acceptedByCodeName[params.row.indicatorCodeName]}
        inputProps={{ 'aria-label': `Include ${params.row.label}` }}
        onClick={() => updateAccepted(params.row.indicatorCodeName, !acceptedByCodeName[params.row.indicatorCodeName])}
      />
    ),
  },
  {
    field: 'label',
    headerName: 'Coverage',
    flex: 2,
    sortable: false,
    renderCell: (params: TableGridRenderCellParams) => <Typography variant='bodySmall'>{params.row.label}</Typography>,
  },
  {
    field: 'termPremium',
    headerName: 'Estimated Premium',
    flex: 1,
    sortable: false,
    renderCell: (params: TableGridRenderCellParams) => (
      <Typography variant='bodySmall'>{formatCurrency(params.row.termPremium)}</Typography>
    ),
  },
];
